module.exports = __webpack_public_path__ + "static/18import-ce75ed2b4c9c5a9273a451e29df6bb0e.png";